import React from "react";
import { Grid, Typography } from '@material-ui/core';
import Projects from './ProjectData';
import DataCard from './DataCard';

const Project = () => {

    return(
      <React.Fragment>
        <Grid container className='centering' spacing={3} >
          <Grid item xs={12} >
            <p className='PageHeader'>PROJECTS</p>
          </Grid>
          {Projects.map((item) => (
            item.Complete === "true" ?
              <Grid item xs={12} sm={6} md={4}>
                <DataCard item={item} />
              </Grid> 
              : null
            )
          )}
        </Grid>
      </React.Fragment>
    )

  } 

export default Project;